module.exports = __webpack_public_path__ + "media/images/gallery/constellations/corona_australis/cra_vis-e2d488f15c8906c2f14cf9a5cd6457ed.jpg";